import BLOCKS from '../../../universal/filzfelt/blocks'
import PATTERNS from '../../../universal/filzfelt/patterns'
import SP_BLOCKS from '../../../universal/spinneybeck/blocks'
import SP_PATTERNS from '../../../universal/spinneybeck/patterns'

export default (id, width, height, old) => {
  const pattern = PATTERNS[id] || SP_PATTERNS[id]

  let ox = 0
  let oy = 0
  if ('origin' in pattern) {
    ox = pattern.origin[0] * width
    oy = pattern.origin[1] * height
  }
  if ('align' in pattern) {
    if (pattern.align[0]) ox += alignment(pattern.align[0], width)
    if (pattern.align[1]) oy += alignment(pattern.align[1], height)
  }
  if ('changeViewport' in pattern) {
    oy += (height-66)
  }
  const [
    [ix, iy],
    [jx, jy]
  ] = pattern.repeat

  const result = {}
  const queue = new Set()
  queue.add('0,0')

  for (const key of queue) {
    const [i, j] = key.split(',').map(n => Number(n))
    const ex = ox + (i * ix) + (j * jx)
    const ey = oy + (i * iy) + (j * jy)

    let stop = true
    for (const [i, b] of pattern.blocks.entries()) {
      const blockKey = `${key},${i}`
      const color = old && old[blockKey] && old[blockKey].color
      const x = ex + (b.x || 0)
      const y = ey + (b.y || 0)
      const r = b.r

      const full = block => {
        result[blockKey] = block
      }

      const partial = block => {
        block.partial = true
        result[blockKey] = block
      }

      const BLOCK = BLOCKS[b.id] || SP_BLOCKS[b.id]

      // blocks defined by border points
      if (BLOCK.border) {
        const points = transform(BLOCK.border, x, y, r)
        const block = { id: b.id, points, color }
        if (isFullyInside(points, width, height)) {
          full(block)
          stop = false
        } else if (isPartiallyInside(points, width, height)) {
          if (!pattern.fullBlocksOnly) {
            partial(block)
          }
          stop = false
        }
        continue
      }

      // blocks defined by bounding size
      if (BLOCK.bounds) {
        const [w, h, ox = 0, oy = 0] = BLOCK.bounds
        const box = transform([
          [ox, oy],
          [w, oy],
          [w, h],
          [ox, h]
        ], x, y, r)
        const block = { id: b.id, x, y, r, color }
        if (isFullyInside(box, width, height)) {
          full(block)
          stop = false
        } else if (isPartiallyInside(box, width, height)) {
          if (!pattern.fullBlocksOnly) {
            partial(block)
          }
          stop = false
        }
      }
    }

    if (!stop) {
      queue
        .add(`${i - 1},${j}`)
        .add(`${i},${j - 1}`)
        .add(`${i + 1},${j}`)
        .add(`${i},${j + 1}`)
    }
  }

  return result
}

const alignment = ([span, odd, even, rest = 0] = [], base) => {
  const n = (base / span) | 0
  const r = (base / span) % 1
  return ((!n || n % 2) ? odd : even) + (rest * r * span / 2)
}

const transform = (points, x, y, r) => {
  points = points.map(([px, py]) => [x + px, y + py])
  if (r == null) {
    return points
  }
  let [a, cx, cy] = r
  cx += x
  cy += y
  a *= Math.PI / 180
  return points.map(([px, py]) => [
    cx + Math.cos(a) * (px - cx) - Math.sin(a) * (py - cy),
    cy + Math.sin(a) * (px - cx) + Math.cos(a) * (py - cy)
  ])
}

const isFullyInside = (points, w, h) => {
  for (const [x, y] of points) {
    if (x < 0 || y < 0 || x > w || y > h) {
      return false
    }
  }
  return true
}

const isPartiallyInside = (points, w, h) => {
  const boxPoints = [[0, 0], [w, 0], [w, h], [0, h]]
  for (const line1 of lines(points)) {
    for (const line2 of lines(boxPoints)) {
      if (intersects(line1, line2)) {
        return true
      }
    }
  }
  return false
}

const ccw = (a, b, c) => {
  return (c[1] - a[1]) * (b[0] - a[0]) > (b[1] - a[1]) * (c[0] - a[0])
}

const floatEq = (a, b) => {
  return Math.abs(a - b) < Number.EPSILON
}

const pointEq = (a, b) => {
  return floatEq(a[0], b[0]) && floatEq(a[1], b[1])
}

const adjoining = (a, b, c, d) => {
  return pointEq(a, c) || pointEq(a, d) || pointEq(b, c) || pointEq(b, d)
}

const intersects = ([a, b], [c, d]) => {
  // if lines form an angle, don't consider them intersecting
  return !adjoining(a, b, c, d) &&
    ccw(a, c, d) !== ccw(b, c, d) &&
    ccw(a, b, c) !== ccw(a, b, d)
}

function * lines (points) {
  for (let i = 0; i < points.length - 1; ++i) {
    yield [points[i], points[i + 1]]
  }
  yield [points[points.length - 1], points[0]]
}



// WEBPACK FOOTER //
// ./src/client/lib/filzfelt/generate-pattern.js